import { render } from "./NavigationTabbedBar.vue?vue&type=template&id=b88916b6&scoped=true&ts=true"
import script from "./NavigationTabbedBar.vue?vue&type=script&lang=ts"
export * from "./NavigationTabbedBar.vue?vue&type=script&lang=ts"

import "./NavigationTabbedBar.vue?vue&type=style&index=0&id=b88916b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88916b6"]])

export default __exports__